(function () {
  'use strict';

  var config = window.PG_ABTESTS || {};
  var experiments = Array.isArray(config.experiments) ? config.experiments : [];
  var endpoint = config.event_endpoint || '';
  var cookieDays = Number(config.cookie_days || 30);

  function normalizePath(path) {
    return String(path || '').replace(/\/+$/, '').toLowerCase() || '/';
  }

  function readCookie(name) {
    var prefix = name + '=';
    return document.cookie.split(';').map(function (part) {
      return part.trim();
    }).filter(function (part) {
      return part.indexOf(prefix) === 0;
    }).map(function (part) {
      return decodeURIComponent(part.slice(prefix.length));
    })[0] || '';
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
  }

  function visitorId() {
    var name = 'pg_ab_vid';
    var id = readCookie(name);
    if (id) return id;
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      id = window.crypto.randomUUID();
    } else {
      id = 'v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    writeCookie(name, id, 365);
    return id;
  }

  function hashString(value) {
    var hash = 2166136261;
    var input = String(value || '');
    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function chooseVariant(experiment, id) {
    var split = experiment.split || { A: 50, B: 50 };
    var entries = Object.keys(split).map(function (variant) {
      return [variant, Number(split[variant])];
    }).filter(function (entry) {
      return Number.isFinite(entry[1]) && entry[1] > 0;
    });
    var total = entries.reduce(function (sum, entry) {
      return sum + entry[1];
    }, 0);
    if (!entries.length || total <= 0) return 'A';
    var bucket = hashString(experiment.id + '|' + id) % total;
    var cursor = 0;
    for (var i = 0; i < entries.length; i += 1) {
      cursor += entries[i][1];
      if (bucket < cursor) return entries[i][0];
    }
    return entries[entries.length - 1][0];
  }

  function matchingExperiment() {
    var path = normalizePath(window.location.pathname);
    return experiments.find(function (experiment) {
      if (experiment.status !== 'active') return false;
      return (experiment.target_paths || []).some(function (target) {
        return normalizePath(target) === path;
      });
    }) || null;
  }

  function savedExperiment() {
    return experiments.find(function (experiment) {
      if (experiment.status !== 'active') return false;
      return Boolean(readCookie('pg_ab_' + experiment.id));
    }) || null;
  }

  function queryVariant(experiment) {
    if (!experiment.allow_query_override) return '';
    var value = new URLSearchParams(window.location.search).get('pg_ab_variant') || '';
    return experiment.split && Object.prototype.hasOwnProperty.call(experiment.split, value) ? value : '';
  }

  function utmPayload() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    return keys.reduce(function (out, key) {
      out[key] = params.get(key) || '';
      return out;
    }, {});
  }

  function assignment(experiment, options) {
    var canCreate = !options || options.canCreate !== false;
    var id = visitorId();
    var cookieName = 'pg_ab_' + experiment.id;
    var saved = readCookie(cookieName);
    if (!saved && !canCreate) return null;
    var variant = (canCreate ? queryVariant(experiment) : '') || saved || chooseVariant(experiment, id);
    writeCookie(cookieName, variant, cookieDays);
    return {
      experiment_id: experiment.id,
      variant: variant,
      visitor_id: id,
      assignment_id: experiment.id + ':' + id,
      assigned_at: new Date().toISOString()
    };
  }

  function applyVisibility(hit) {
    document.documentElement.removeAttribute('data-pg-ab-variant');
    document.querySelectorAll('[data-pg-ab-experiment][data-pg-ab-variant-only]').forEach(function (node) {
      if (node.getAttribute('data-pg-ab-experiment') === hit.experiment_id) {
        node.hidden = true;
      }
    });
    document.documentElement.setAttribute('data-pg-ab-test', hit.experiment_id);
    document.documentElement.setAttribute('data-pg-ab-variant', hit.variant);
    document.querySelectorAll('[data-pg-ab-experiment][data-pg-ab-variant-only]').forEach(function (node) {
      var sameExperiment = node.getAttribute('data-pg-ab-experiment') === hit.experiment_id;
      var sameVariant = node.getAttribute('data-pg-ab-variant-only') === hit.variant;
      node.hidden = !(sameExperiment && sameVariant);
    });
  }

  function assetUrl(file) {
    var script = document.currentScript;
    if (!script || !script.src) {
      var scripts = document.querySelectorAll('script[src*="pg-abtest-v"]');
      script = scripts[scripts.length - 1] || null;
    }
    if (script && script.src) {
      return script.src.replace(/pg-abtest-v[0-9]+\.js(?:\?.*)?$/u, file);
    }
    return '/cdn/shop/t/1/assets/' + file;
  }

  function ensureBPageFallbackStyles() {
    if (document.getElementById('pgb-fallback-styles')) return;
    var style = document.createElement('style');
    style.id = 'pgb-fallback-styles';
    style.textContent = [
      '.pgb-product-gallery{display:grid;gap:12px;margin:0 0 18px}',
      '.pgb-gallery-main{border:1px solid #d6e4f4;background:#f6f9fc;overflow:hidden}',
      '.pgb-gallery-main img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover}',
      '.pgb-gallery-strip{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}',
      '.pgb-gallery-strip img{width:100%;aspect-ratio:1/1;object-fit:cover;border:1px solid #d6e4f4;background:#fff}',
      '[data-pg-ab-experiment][data-pg-ab-variant-only][hidden]{display:none!important}',
      'html[data-pg-ab-variant="B"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B"] .text-block[class*="__text_aEtTtq"]{display:none!important}',
      '.pgb-desc{--pgb-ink:#101828;--pgb-muted:#667085;--pgb-line:#d6e4f4;--pgb-blue:#1263d8;--pgb-navy:#071a3a;color:var(--pgb-ink);font-family:var(--font-body--family,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif)}',
      '.pgb-desc-band{max-width:1180px;margin:0 auto;padding:46px 18px;border-top:1px solid var(--pgb-line);display:grid;grid-template-columns:minmax(0,1fr);gap:24px;align-items:center}',
      '.pgb-desc-band:nth-child(odd){background:#f7fbff}',
      '.pgb-desc h2{margin:8px 0 12px;font-size:clamp(28px,4vw,44px);line-height:1.05;letter-spacing:0;color:var(--pgb-navy)}',
      '.pgb-desc p{margin:0;color:var(--pgb-muted);line-height:1.6;font-size:16px}',
      '.pgb-kicker{display:inline-flex;padding:6px 10px;border:1px solid rgba(18,99,216,.22);color:var(--pgb-blue);font-size:12px;font-weight:900;text-transform:uppercase;background:#fff}',
      '.pgb-signal-row,.pgb-coverage-grid,.pgb-step-grid,.pgb-room-list,.pgb-review-grid,.pgb-faq-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:18px}',
      '.pgb-signal-row>div,.pgb-coverage-grid article,.pgb-step-grid article,.pgb-room-list>div,.pgb-review-grid article,.pgb-faq-grid details{background:#fff;border:1px solid var(--pgb-line);padding:16px}',
      '.pgb-desc strong{display:block;margin-bottom:6px;color:var(--pgb-navy)}',
      '.pgb-review-grid span{display:block;color:#f59e0b;font-weight:900;margin-bottom:6px}',
      '.pgb-desc-media img{display:block;width:100%;border:1px solid var(--pgb-line);background:#fff}',
      '@media(min-width:860px){.pgb-desc-band{grid-template-columns:1.05fr .95fr}.pgb-problem{display:block}.pgb-proof{grid-template-columns:1fr .8fr}}',
      '@media(max-width:720px){.pgb-gallery-strip,.pgb-signal-row,.pgb-coverage-grid,.pgb-step-grid,.pgb-room-list,.pgb-review-grid,.pgb-faq-grid{grid-template-columns:1fr}.pgb-desc-band{padding:38px 16px}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function hideOriginalDescriptionForB() {
    document.querySelectorAll('rte-formatter.text-block[class*="__text_aEtTtq"], .text-block[class*="__text_aEtTtq"]').forEach(function (node) {
      node.hidden = true;
      node.setAttribute('data-pg-ab-fallback-hidden-description', 'true');
    });
  }

  function bGalleryHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-product-gallery pgb-js-fallback" aria-label="PestGuard product offer media">',
      '<div class="pgb-gallery-main"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free whole-home pest plan" loading="eager"></div>',
      '<div class="pgb-gallery-strip">',
      '<img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free offer image" loading="eager">',
      '<img src="' + room + '" alt="PestGuard bedroom kitchen storage room coverage plan" loading="lazy">',
      '<img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic coverage image" loading="lazy">',
      '<img src="' + proof + '" alt="PestGuard verified buyer and guarantee proof image" loading="lazy">',
      '</div></div>'
    ].join('');
  }

  function bDescriptionHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-desc pgb-js-fallback">',
      '<section class="pgb-desc-band pgb-result"><div class="pgb-copy"><span class="pgb-kicker">No more pests or it is free</span><h2>A cleaner way to make your home feel protected again.</h2><p>PestGuard is built for people who do not want sprays, trap cleanup, or a home that feels uncomfortable at night. Plug it in, leave it running, and support the rooms where pests are most likely to move, hide, and return.</p><div class="pgb-signal-row"><div><strong>18,000+ homes</strong><p>Used room by room by shoppers who want a lower-maintenance setup.</p></div><div><strong>90-day guarantee</strong><p>If it is not the right fit, the purchase is backed by the existing money-back policy.</p></div><div><strong>No chemical routine</strong><p>No spray smell, poison residue, or daily trap cleanup around the home.</p></div></div></div><div class="pgb-desc-media"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free whole-home pest plan" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-problem"><div class="pgb-copy"><span class="pgb-kicker">Hidden-route problem</span><h2>Seeing one pest usually means the route is already active.</h2><p>Sprays and traps focus on what you can see. PestGuard supports the environment pests move through, including baseboards, cabinets, outlets, shared walls, and quiet storage areas.</p><div class="pgb-coverage-grid"><article><strong>Visible signs are only the surface</strong><p>The stressful part is usually the repeat path behind the room.</p></article><article><strong>Walls and furniture matter</strong><p>Closed doors, corners, and room layout reduce practical coverage from a single device.</p></article><article><strong>The goal is continuous pressure</strong><p>Keep the room supported every day instead of reacting only when activity appears.</p></article></div></div></section>',
      '<section class="pgb-desc-band pgb-mechanism"><div class="pgb-copy"><span class="pgb-kicker">Dual-Wave technology</span><h2>Plug it in once. Let ultrasonic support run every day.</h2><p>PestGuard emits Dual-Wave ultrasonic pulses designed to make common hiding routes behind walls, baseboards, outlets, and cabinets less comfortable for pests over time.</p><div class="pgb-step-grid"><article><strong>1. Plug into an open outlet</strong><p>Place one device in each target room or zone.</p></article><article><strong>2. Leave it running 24/7</strong><p>No refills, chemical smell, trap cleanup, or daily routine.</p></article><article><strong>3. Give the room time</strong><p>Use it consistently while reducing food sources, clutter, and entry gaps.</p></article></div></div><div class="pgb-desc-media"><img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic technology image" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-coverage"><div class="pgb-copy"><span class="pgb-kicker">Coverage plan</span><h2>One device can help one zone. A bundle gives you a plan.</h2><p>Most homes need coverage in more than one place. The Buy 3 Get 3 Free offer works as a room plan, not just extra devices.</p><div class="pgb-room-list"><div><strong>Bedroom</strong><p>Support the room where nighttime activity feels most stressful.</p></div><div><strong>Kitchen</strong><p>Cover pantry routes, cabinets, baseboards, and walls pests travel behind.</p></div><div><strong>Storage areas</strong><p>Add coverage for closets, laundry rooms, basements, garages, luggage, and seasonal boxes.</p></div></div></div><div class="pgb-desc-media"><img src="' + room + '" alt="PestGuard whole-home room coverage illustration" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-proof"><div class="pgb-copy"><span class="pgb-kicker">Social proof</span><h2>Reviews should make the promise feel safer, not louder.</h2><div class="pgb-review-grid"><article><span>5-star review</span><strong>Lena S. - Brooklyn apartment</strong><p>"The scratching in the walls stopped first, then the roaches. I love that it repels them without spraying poison where I cook."</p></article><article><span>5-star review</span><strong>Marcus H. - 6-pack</strong><p>"We plugged one into every bedroom and the basement. It is nice knowing it is on 24/7 without chemicals."</p></article><article><span>5-star review</span><strong>Nicole R. - short-term rental host</strong><p>"I use these in every unit between guests. It is cheaper than one bad review and I do not have to bomb the place."</p></article></div></div><div class="pgb-desc-media"><img src="' + proof + '" alt="PestGuard verified buyer and homes proof" loading="lazy"></div></section>',
      '<section class="pgb-desc-band"><div class="pgb-copy"><span class="pgb-kicker">Lower-risk setup</span><h2>No sprays. No trap cleanup. Backed by a 90-day guarantee.</h2><p>PestGuard fits into a cleaner routine: reduce food sources, seal gaps, reduce clutter, and monitor high-activity areas.</p><div class="pgb-faq-grid"><details open><summary>Does one device cover the whole home?</summary><p>No. Use one device per target room or zone because walls and furniture reduce practical coverage.</p></details><details><summary>What makes it different from sprays or traps?</summary><p>Sprays and traps react to visible pests. PestGuard is a continuous plug-in repeller for the room.</p></details><details><summary>What makes the purchase lower risk?</summary><p>The order is backed by the same 90-day money-back guarantee already used on the current page.</p></details></div></div></section>',
      '</div>'
    ].join('');
  }

  function installBPageFallback(hit) {
    if (hit.variant !== 'B') return;
    ensureBPageFallbackStyles();
    hideOriginalDescriptionForB();
    if (document.querySelector('.pgb-product-gallery')) return;
    var media = document.querySelector('.product-information__media');
    var productInfo = document.querySelector('.product-information');
    if (!media || !productInfo) return;
    Array.prototype.forEach.call(media.children, function (node) {
      node.hidden = true;
      node.setAttribute('data-pg-ab-fallback-hidden', 'true');
    });
    media.insertAdjacentHTML('afterbegin', bGalleryHtml());
    if (!document.querySelector('.pgb-desc')) {
      productInfo.insertAdjacentHTML('afterend', bDescriptionHtml());
    }
  }

  function queueBPageFallback(hit) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        installBPageFallback(hit);
      }, { once: true });
    } else {
      installBPageFallback(hit);
    }
  }

  function addFormProperties(hit) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      [
        ['properties[_pg_ab_test]', hit.experiment_id],
        ['properties[_pg_ab_variant]', hit.variant],
        ['properties[_pg_ab_assignment]', hit.assignment_id]
      ].forEach(function (pair) {
        var input = form.querySelector('input[name="' + pair[0] + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          form.appendChild(input);
        }
        input.value = pair[1];
      });
    });
  }

  function updateCartAttributes(hit) {
    var marker = 'pg_ab_cart_' + hit.experiment_id + '_' + hit.variant;
    if (sessionStorage.getItem(marker)) return;
    sessionStorage.setItem(marker, '1');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          pg_ab_test: hit.experiment_id,
          pg_ab_variant: hit.variant,
          pg_ab_assignment: hit.assignment_id,
          pg_ab_assigned_at: hit.assigned_at
        }
      })
    }).catch(function () {});
  }

  function sendEvent(hit, eventName, extra, dedupeKey) {
    if (dedupeKey && sessionStorage.getItem(dedupeKey)) return null;
    var payload = Object.assign({
      event_name: eventName,
      page_path: window.location.pathname,
      page_url: window.location.href,
      referrer: document.referrer || '',
      screen_width: window.innerWidth || 0
    }, hit, utmPayload(), extra || {});
    if (dedupeKey) sessionStorage.setItem(dedupeKey, '1');
    if (endpoint) {
      var body = JSON.stringify(payload);
      if (window.fetch) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          body: body,
          keepalive: true
        }).catch(function () {
          if (navigator.sendBeacon) {
            navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
          }
        });
      } else if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      }
    }
    window.dispatchEvent(new CustomEvent('pg_abtest_event', { detail: payload }));
    return payload;
  }

  function trackSession(hit) {
    var key = 'pg_ab_session_' + hit.experiment_id;
    var payload = sendEvent(hit, 'session_assigned', {}, key);
    if (payload) window.dispatchEvent(new CustomEvent('pg_abtest_assigned', { detail: payload }));
  }

  function closestMatch(node, selector) {
    var current = node;
    while (current) {
      if (current.nodeType !== 1) {
        current = current.parentElement || current.parentNode || null;
        continue;
      }
      if (current.matches && current.matches(selector)) return current;
      current = current.parentElement || (current.getRootNode && current.getRootNode().host) || null;
    }
    return null;
  }

  function trackAddToCart(hit, source) {
    sendEvent(hit, 'add_to_cart', {
      event_source: source || 'product_form'
    }, 'pg_ab_add_to_cart_' + hit.experiment_id);
  }

  function trackReachedCheckout(hit, source) {
    sendEvent(hit, 'reached_checkout', {
      event_source: source || 'checkout_button'
    }, 'pg_ab_reached_checkout_' + hit.experiment_id);
  }

  function installInteractionTracking(hit) {
    if (window.__pgAbInteractionTrackingInstalled) return;
    window.__pgAbInteractionTrackingInstalled = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="/cart/add"]')) {
        trackAddToCart(hit, 'cart_add_form_submit');
      }
      if (form.matches('form[action*="/checkout"]') || form.querySelector('[name="checkout"]')) {
        trackReachedCheckout(hit, 'checkout_form_submit');
      }
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target;
      var cartAddForm = closestMatch(target, 'form[action*="/cart/add"]');
      if (cartAddForm && closestMatch(target, 'button, input[type="submit"], [role="button"], .shopify-payment-button__button, shopify-accelerated-checkout')) {
        if (closestMatch(target, '.shopify-payment-button__button, shopify-accelerated-checkout')) {
          trackReachedCheckout(hit, 'dynamic_checkout_button');
        } else {
          trackAddToCart(hit, 'cart_add_button_click');
        }
      }

      if (closestMatch(target, 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-shopify="payment-button"], [data-testid*="Checkout"]')) {
        trackReachedCheckout(hit, 'checkout_button_click');
      }
    }, true);
  }

  var targetExperiment = matchingExperiment();
  var experiment = targetExperiment || savedExperiment();
  if (!experiment) return;
  var hit = assignment(experiment, { canCreate: Boolean(targetExperiment) });
  if (!hit) return;
  window.PG_ABTEST = hit;
  if (targetExperiment) {
    applyVisibility(hit);
    queueBPageFallback(hit);
  }
  addFormProperties(hit);
  updateCartAttributes(hit);
  installInteractionTracking(hit);
  if (targetExperiment) trackSession(hit);
})();
